import Axios, { AxiosRequestConfig, AxiosInstance } from "axios";
import { environment } from "../environment";
import { registerAxiosInstance } from "./AxiosTokenManager";
import { addUnauthorizedInterceptor } from "./UnauthorizedInterceptor";

// Create initial ingest API instance with placeholder baseURL
export const ingestAxiosInstance: AxiosInstance = Axios.create({
  baseURL: "http://localhost:8001", // placeholder until environment loads
});

// Register for token management immediately
registerAxiosInstance(ingestAxiosInstance);

// Handle 401 responses by redirecting to auth flow
addUnauthorizedInterceptor(ingestAxiosInstance);

let isInitialized = false;

// Initialize ingest API instance baseURL asynchronously
const initializeIngestAxiosInstance = async (): Promise<AxiosInstance> => {
  if (isInitialized) {
    return ingestAxiosInstance;
  }

  const env = await environment();

  // Update the baseURL on the existing instance
  ingestAxiosInstance.defaults.baseURL = env.INGEST_URL;

  isInitialized = true;
  return ingestAxiosInstance;
};

// Export for direct use if needed
export const getIngestAxiosInstance = initializeIngestAxiosInstance;

// Ingest API mutator for orval
export const customIngestInstance = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T & { cancel?: () => void }> => {
  const ingestAxiosInstance = await getIngestAxiosInstance();
  const controller = new AbortController();
  await initializeIngestAxiosInstance(); // Ensure baseURL is set

  const promise = ingestAxiosInstance({
    ...config,
    ...options,
    signal: controller.signal,
  }).then(({ data }: { data: T }) => data);

  // Add cancel functionality — Promise doesn't have a cancel property by default;
  // this pattern is used by Orval to support request cancellation.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (promise as any).cancel = () => controller.abort();
  return promise;
};
